export const fruitsData = [
  {
    id: 1,
    name: "Strawberry",
    img: "https://firebasestorage.googleapis.com/v0/b/socail-meda.appspot.com/o/pexels-ave-calvar-martinez-6944172.jpg?alt=media&token=2dc13543-69ee-4972-95d3-699df58d06de",
  },
  {
    id: 2,
    name: "Mango",
    img: "https://firebasestorage.googleapis.com/v0/b/socail-meda.appspot.com/o/pexels-julie-aagaard-2294471.jpg?alt=media&token=ccb90462-634e-4bbc-b312-2ccf1e2af0ba",
  },
  {
    id: 3,
    name: "Guava",
    img: "https://firebasestorage.googleapis.com/v0/b/socail-meda.appspot.com/o/Guava.jpeg?alt=media&token=093a609d-c527-4840-afc7-b81fe9707340",
  },
  {
    id: 4,
    name: "Orange",
    img: "https://firebasestorage.googleapis.com/v0/b/socail-meda.appspot.com/o/Orange.jpeg?alt=media&token=6075ecc4-91e6-43d3-879d-2b65e949079c",
  },
];
